
(function(){
    var getURLParams = function(paramName){
        /*
         * 获取url中的参数
         * @param {string} url
         * @param {string} [paramName]
         *
         * @return {object} or {string}
         */
        var o = {},
            url = window.location.href,
            search_str = [].concat(url.match(/\?.*/))[0] || '',
            params_str = search_str.replace('?', '');
        var params_arr = params_str.split('&');
        for (var i = 0; i < params_arr.length; i++) {
            var arr = params_arr[i].split('=');
            o[arr[0]] = arr[1];
        }
        if (paramName) {
            return o[paramName];
        }
        return o;
    }
    var appid = getURLParams('appid');
    var color = getURLParams('color');
    if(color) localStorage.setItem('color',color);
    if(appid) localStorage.setItem('appid',appid);
    var class_name = color || localStorage.getItem('color') || appid || localStorage.getItem('appid');   
    $('body').addClass(class_name).show();

    var channelTracker = function(){
        var r = window.location.search.substr(1).match(new RegExp("(^|&)channel=([^&]*)(&|$)"));
        if (r !== null) {
          var channel = unescape(r[2]);
          // Utils.Tracker.send({
          //     data: {
          //         f: "wifiins",
          //         b: channel
          //     }
          // })
        }
        localStorage.setItem('channel',channel);
    },
    //弹窗
    model = function(opt){
        $('.model .foot').show();
        $('.model .btns').hide();
        if(opt=='hide'){
            $('.model').hide();
        }else{
            $('.model .title').html(opt.title);
            $('.model .content').html(opt.content);
            $('.model .foot').html(opt.foot);
            $('.model').show(); 
        }
    },
    //确认窗
    confirm = function(opt){
        $('.model .foot').hide();
        $('.model .btns').show();
        $('.model .confirm').unbind('click').bind('click',function(){
            opt.callback();
        });
        $('.model .title').html(opt.title);
        $('.model .content').html(opt.content);
        $('.model').show(); 
    },
    bindEvent = function(){
        $('.model .foot').bind('click',function(){
            model('hide');
        });
        $('.model .cancel').bind('click',function(){
            $('.model').hide();
        });
    };
    window.safe={
        model : model,
        confirm : confirm,
        bindModelEvent : bindEvent,
        channelTracker : channelTracker
    }
})();



// WEBPACK FOOTER //
// ./src/scripts/safe.js